import React, { memo } from "react";
import { VesselVesselProvider } from "./state/vesselVesselContext";
import VesselVesselView from "./components/VesselVesselView";

function VesselVesselMatrixMain(props) {
  return (
    <VesselVesselProvider>
      <VesselVesselView {...props} />
    </VesselVesselProvider>
  );
}

export default memo(VesselVesselMatrixMain);
